// extracted by mini-css-extract-plugin
export default {"loading":"BFamilyTagPopperItem-module_loading_b72d0228","popover":"BFamilyTagPopperItem-module_popover_b382cbbd"};